import React from "react";
import PropTypes from "prop-types";

export function TrailingNode({ children, show, node }) {
  return (
    <React.Fragment>
      {children}
      {show && node}
    </React.Fragment>
  );
}

TrailingNode.propTypes = {
  children: PropTypes.node,
  node: PropTypes.node,
  show: PropTypes.bool,
};

TrailingNode.defaultProps = {
  children: undefined,
  node: undefined,
  show: false,
};

export default TrailingNode;
